// extracted by mini-css-extract-plugin
module.exports = {"customLinks":"uiSettings_customLinks__2g9db"};